import { render, staticRenderFns } from "./loading-unloading-list.vue?vue&type=template&id=2f964d21&"
import script from "./loading-unloading-list.vue?vue&type=script&lang=js&"
export * from "./loading-unloading-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports